import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import CloseIcon from '@material-ui/icons/Close'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import { styles } from './style'

const StyledModal = ({
  classes,
  isOpen,
  onClose,
  onConfirm,
  confirmLabel,
  title,
  text,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="responsive-dialog-title"
      className={classes.dialog}
      cypress_id="responsiveDialog"
    >
      <Box display={'flex'} justifyContent={'end'} style={{ height: '60px' }}>
        <Button color="inherit" size="small" onClick={onClose}>
          <CloseIcon fontSize="default" />
        </Button>
      </Box>
      <Box className={classes.contentWrap}>
        <DialogContent>
          <DialogTitle id="responsive-dialog-title" className={classes.title}>
            {title}
          </DialogTitle>
          <div className={classes.content}>
            <div className={classes.text}>{text}</div>
            <div />
            <div className={classes.buttonWrap}>
              <button
                onClick={onClose}
                className={classes.cancelButton}
                cypress_id="cancelBtn"
              >
                Cancel
              </button>
              <button
                onClick={onConfirm}
                className={classes.actionButton}
                cypress_id="confirmBtn"
              >
                {confirmLabel}
              </button>
            </div>
          </div>
        </DialogContent>
      </Box>
    </Dialog>
  )
}

export default withStyles(styles)(StyledModal)
